import React, { useCallback, useEffect, useState } from 'react'
import message from 'antd/lib/message'

import { CloseIcon, PrimaryButton } from 'components/index'
import { apiManager } from 'helpers'

import Overlay from 'components/AuthModal/components/Overlay'
import Modal from 'components/AuthModal/components/Modal'
import ProfileInput from 'components/Profile/ProfileInput'
import { OVERLAY } from 'components/AuthModal/styles'

const ReferralModal = ({ show, onClose, onComplete }) => {
  const [referralCode, setReferralCode] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    setReferralCode('')
  }, [show])

  const handleSave = useCallback(
    async e => {
      e.preventDefault()
      setIsSubmitting(true)

      const showError = errorMessage => {
        message.destroy()
        message.error(errorMessage)
      }

      try {
        const response = await apiManager.updateInviteReferralCode({ referralCode })
        if (response?.data?.accepted) {
          message.success('Referral Code Applied')
          await onComplete()
        } else {
          showError('Invalid code, please try again')
        }
      } catch (error) {
        showError(error.message || 'Invalid code, please try again')
      } finally {
        setIsSubmitting(false)
      }
    },
    [referralCode, onComplete]
  )

  return (
    <Overlay show={show} className={OVERLAY} preventEscBackdropClose>
      <Modal innerClassName="overflow-y-scroll flex flex-col rounded-t-3xl overflow-hidden md:rounded-xl">
        <form
          onSubmit={handleSave}
          className="relative flex flex-col text-white items-stretch h-full w-full p-4 pb-8 bg-codGray md:py-8 md:px-7 md:w-108 md:max-h-screen"
        >
          <div className="flex items-center justify-between mb-2">
            <div className="text-lg font-semibold font-ownersWide">Enter referral code</div>
            <button
              className="bg-white bg-opacity-20 w-6 h-6 rounded-full flex items-center justify-center"
              type="button"
              onClick={() => onClose()}
            >
              <CloseIcon className="w-2 h-2 text-white" />
            </button>
          </div>
          <div className="mt-7 mb-16">
            <ProfileInput
              name="referralCode"
              value={referralCode}
              classNames={{ input: 'text-left md:text-left' }}
              onChange={e => setReferralCode(e.target.value)}
              required
            />
          </div>
          <PrimaryButton
            type="submit"
            className="w-full bg-secondaryGradient"
            loadingColor="text-black"
            textColor="text-black"
            loading={isSubmitting}
          >
            Enter
          </PrimaryButton>
        </form>
      </Modal>
    </Overlay>
  )
}

export default ReferralModal
